import {
  CertificateRadio,
  CertificateType,
  CertificateValueBorn,
  CertificateValueCitizenship,
  CertificateValueCivilUnion,
  CertificateValueDeath,
  CertificateValueMarriage,
} from 'civil-status/view-models/document-birth-form';

export const transformCertificateTitle = (item?: CertificateRadio | null): CertificateRadio => {
  let type = '';
  let value = '';

  if (item?.type === CertificateType.nascita) {
    type = 'Nascita';
  }

  if (item?.type === CertificateType.matrimonio) {
    type = 'Matrimonio';
  }

  if (item?.type === CertificateType.morte) {
    type = 'Morte';
  }

  if (item?.type === CertificateType.unioneCivile) {
    type = 'Unione Civile';
  }

  if (item?.type === CertificateType.cittadinanza) {
    type = 'Cittadinanza';
  }

  const isCertificato =
    item?.element?.key?.codiceDocumento === CertificateValueBorn.certificato ||
    item?.element?.key?.codiceDocumento === CertificateValueMarriage.certificato ||
    item?.element?.key?.codiceDocumento === CertificateValueDeath.certificato ||
    item?.element?.key?.codiceDocumento === CertificateValueCivilUnion.certificato;

  if (isCertificato) {
    value = 'Certificato';
  }

  const isCopia =
    item?.element?.key?.codiceDocumento === CertificateValueBorn.copia ||
    item?.element?.key?.codiceDocumento === CertificateValueMarriage.copia ||
    item?.element?.key?.codiceDocumento === CertificateValueDeath.copia ||
    item?.element?.key?.codiceDocumento === CertificateValueCivilUnion.copia ||
    item?.element?.key?.codiceDocumento === CertificateValueCitizenship.copia;

  if (isCopia) {
    value = 'Copia Conforme';
  }

  const isEstratto =
    item?.element?.key?.codiceDocumento === CertificateValueBorn.estratto ||
    item?.element?.key?.codiceDocumento === CertificateValueMarriage.estratto ||
    item?.element?.key?.codiceDocumento === CertificateValueDeath.estratto ||
    item?.element?.key?.codiceDocumento === CertificateValueCivilUnion.estratto;

  if (isEstratto) {
    value = 'Estratto';
  }

  const isEstrattoVienna =
    item?.element?.key?.codiceDocumento === CertificateValueBorn.estrattoVienna ||
    item?.element?.key?.codiceDocumento === CertificateValueMarriage.estrattoVienna ||
    item?.element?.key?.codiceDocumento === CertificateValueDeath.estrattoVienna;

  if (isEstrattoVienna) {
    value = 'Estratto Internazionale Vienna';
  }

  const isEstrattoParigi =
    item?.element?.key?.codiceDocumento === CertificateValueBorn.estrattoParigi ||
    item?.element?.key?.codiceDocumento === CertificateValueMarriage.estrattoParigi ||
    item?.element?.key?.codiceDocumento === CertificateValueDeath.estrattoParigi;

  if (isEstrattoParigi) {
    value = 'Estratto Internazionale Parigi';
  }

  return {
    type,
    value,
  } as CertificateRadio;
};
